import assign from 'lodash.assign'

export const SET_MXD = 'SET_MXD'

const intialState = {
  // mxd = Mixpanel Distinct Id
  mxd: null
}

export default function tracking (state = intialState, action) {
  switch (action.type) {
    case SET_MXD:
      return assign({}, state, { mxd: action.mxd })
    default:
      return state
  }
}

export function setMxd (mxd) {
  return {
    type: SET_MXD,
    mxd
  }
}



// WEBPACK FOOTER //
// ./frontend/scripts/reducers/tracking.js